import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './state/store'
import ManageLib from '@lib'
import Components from './components'
import Modal from '@lib/components/modal'
import packageJson from '../package.json'
import { Tag } from 'element-ui'

Vue.use(ManageLib, {
  packageJson,
  router,
  store,
})

Vue.use(Tag)
Vue.use(Modal)
Vue.use(Components)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
